import React from 'react';
import { Navigate } from 'react-router-dom';
import { hasPerm } from '../utils/perm';

export function IfPerm({ perm, children }) {
  if (!hasPerm(perm)) return null;
  return children;
}

export function ProtectedRoute({ perm, element }) {
  if (!hasPerm(perm)) return <Navigate to="/" replace />;
  return element;
}
